import Vue from "vue";

const MODULE = "status/";
const _FIND = "FIND";
const _LIST = "LIST";

export const LIST = MODULE + _LIST;
export const FIND = MODULE + _FIND;

const state = {
  byId: {},
  allIds: []
};

const getters = {
  [_FIND](state) {
    return id => state.byId[id];
  },
  [_LIST](state, getters) {
    if (state.allIds === undefined) return undefined;
    return state.allIds.map(id => getters[_FIND](id)).filter(e => e);
  }
};

const mutations = {
  add: (state, item) => {
    for (let key of Object.keys(item)) {
      Vue.set(state.byId, key, item[key]);
      if (state.allIds.includes(key)) return;
      state.allIds.push(key);
    }
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
